import React from 'react';

const RecordIcon = props => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <circle cx={9} cy={9} r={9} fill="#ED1651" />
  </svg>
);

export default RecordIcon;
